import { Jugador, JugadorJSON } from "./Jugador";

  export interface JugadorConEquipoJSON extends JugadorJSON {
    eq_nombre: string,
  }
  
  
  export class JugadorConEquipo {
    fullnameLike(searchKey: string) {
      return this.jugador.fullnameLike(searchKey);
    }
    getId() {
      return this.jugador.getId();
    }
    toJSON() {
      return {...this.jugador.toJSON(), eq_nombre: this.equipo};
    }
    protected constructor(
      private jugador: Jugador,
      private equipo: string,
    ) {}
  
    static createFrom(
      jugador: Jugador,
      equipo: string,
    ) {
      return new this(
        jugador,
        equipo
      );
    }
  }
  